import { ROLES } from './roles'

// Admin OU flag de dev (employees.is_dev) -- usado pelo guard de rota e pelo menu.
export function canAccessAdminOrDev(role, isDev) {
  return role === ROLES.ADMIN || isDev === true
}

export function canAccessNavItem(item, { role, isDev }) {
  if (item.devOnly) return isDev === true
  if (item.adminOrDev) return canAccessAdminOrDev(role, isDev)
  return item.roles.includes(role)
}

export function filterNavigation(navigation, ctx) {
  return navigation
    .map((group) => ({
      ...group,
      items: group.items
        .map((item) => ({
          ...item,
          children: item.children?.filter((c) => canAccessNavItem(c, ctx)),
        }))
        .filter((item) => {
          if (item.route || item.devOnly) return canAccessNavItem(item, ctx)
          return item.children?.length > 0
        }),
    }))
    .filter((group) => {
      if (group.devOnly) return ctx.isDev === true
      return group.items.length > 0
    })
}
